module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAM1BMVEUAAACqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqoNNXyEAAAAEHRSTlMA8oRTQQzQssR7FhTSs9OxRe6oVAAAAGpJREFUGNNtj0sSgCAMQ1so4A999z+tiGUjZpGZvpm2ifxqD4dqDvuYo9Kl0WcolpJV6GRTVhEQWdGtgUCVF0ghNM/YAMbRXEkDJPgC9RWXkfvR0nxZ/Ki/7cDfSoTrCVYgztFHuRMvN+sGfMoEpzPWwYEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_tip.png
// module id = Vg/W
// module chunks = 9